/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import ViewsVsSalesChart from './ViewsVsSalesChart';

const ViewsVsSalesShow = ({ dir, data, viewReportButton, title }) => {
    const thisMonthData = {};
    data.forEach((item) => {   
        const monthDayYear = moment(item.reportDate).format('MM-DD-YYYY')          
        if (item && thisMonthData[monthDayYear]) {
            thisMonthData[monthDayYear].push(item)
        } else {
            thisMonthData[monthDayYear] = [item]
        }
                   
    })
console.log(thisMonthData)
 //   const max = currentMonthDayCount > prevMonthDayCount ? currentMonthDayCount : prevMonthDayCount;
    const reduceCallback = (acc, item) => acc + Number(item.orderedProductSales)
    const reduceCallbackForPageViews = (acc, item) => acc + Number(item.pageViews)
    const reduceCallbackForSessions = (acc, item) => acc + Number(item.sessions)
    const dataToPlot = []
    
    Object.keys((thisMonthData)).forEach((dayMonthYear) => {
        const orderedProductSales = thisMonthData?.[dayMonthYear].reduce(reduceCallback, 0)
        const pageViews = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForPageViews, 0)
        const sessions = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForSessions, 0)
        dataToPlot.push({
            "reportDate": dayMonthYear,            
            'amount': Number(orderedProductSales),
            'page view': Number(pageViews),
            'sessions': Number(sessions)
        })
    })
console.log(dataToPlot)
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                {/* <div className="card__title row " style={{ position: 'relative' }} >
                    {title}
                    {viewReportButton?.()}
                </div> */}

                {data?.length ? (
                    <ViewsVsSalesChart
                        dataToPlot={dataToPlot}
                        height={400}
                        showTitle={false}
                        dir={dir}
                    />

                ) : 'No data to display'}
            </Card>
        </Col>

    )
}

ViewsVsSalesShow.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
};

ViewsVsSalesShow.defaultProps = {
    title: 'Views Vs Sales',
}

export default ViewsVsSalesShow;
